import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "calendarCell", "bulkPanel", "bulkUserId"]

  change(event) {
    const userId = event.target.value

    this.linkTargets.forEach(link => {
      const url = new URL(link.href, window.location.origin)
      if (userId) {
        url.searchParams.set("user_id", userId)
      } else {
        url.searchParams.delete("user_id")
      }
      link.href = url.toString()
    })

    this.calendarCellTargets.forEach(cell => {
      const baseUrl = cell.dataset.calendarInteractionUrlValue
      const url = new URL(baseUrl, window.location.origin)
      if (userId) {
        url.searchParams.set("user_id", userId)
      } else {
        url.searchParams.delete("user_id")
      }
      cell.dataset.calendarInteractionUrlValue = url.pathname + url.search
    })

    if (this.hasBulkPanelTarget) {
      if (userId) {
        this.bulkPanelTarget.classList.remove("hidden")
        this.bulkUserIdTargets.forEach(input => input.value = userId)
      } else {
        this.bulkPanelTarget.classList.add("hidden")
      }
    }
  }

}
